import { app } from '../../app';
import { Controller } from './sp-verification-source.controller';

app.component('spVerificationSource', {
    bindings: {
        verificationSource: '<',
        tooltipPlacement: '@',
    },
    controller: Controller,
    templateUrl: require('./sp-verification-source.html'),
});



// WEBPACK FOOTER //
// ./src/portal/components/sp-verification-source/sp-verification-source.component.js